<mat-card>
  <mat-card-content>
    <p class="error-header">Zu Ihrer Suche konnten wir keine passenden Artikel anzeigen.</p>
    <p class="error-message">Sie können die Suche anpassen oder uns direkt kontaktieren — wir beraten Sie gerne.</p>
  </mat-card-content>
</mat-card>
